import { mapState } from 'vuex';

export default {
    name: 'error',
    props: ['error'],

    data : function(){

        return {
            loading : false
        }

    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
        label : function(){
            if(_.isObject(this.error)){
                if(this.error.error){
                    return "errors." + this.error.error
                }

                return this.error
            }

            return "errors." + this.error
        }
    }),

    methods : {
        
    },
}